import { Component, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApplicationTypeSelectOption } from 'src/app/models/atom.model';
import { Icons } from 'src/app/utilities/enum';
import { tenant } from 'src/tenants/tenant';
@Component({
    selector: 'app-index',
    templateUrl: './index.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./../../../scss/material.scss'],
    standalone: false
})
export class IndexComponent {
    icons = Icons;
    MortgageTotal: UntypedFormControl;

    yesNoOptions = [
        { type: 'Nee', value: false },
        { type: 'Ja', value: true },
    ];

    testForm = new UntypedFormGroup({
        Country: new UntypedFormControl('ZA')
    })

    countries = [{value: 'NL', name: 'Netherlands'}, {value: 'ZA', name: 'South Africa'}];

    NHGFormControl: UntypedFormControl = new UntypedFormControl('');

    applicationTypeControl_Single: UntypedFormControl;
    applicationTypeControl_Multi: UntypedFormControl;

    applicationTypeSelectOptions_Single: ApplicationTypeSelectOption[] = [];
    applicationTypeSelectOptions_Multi: ApplicationTypeSelectOption[] = [];

    constructor() {
        this.MortgageTotal = new UntypedFormControl('420');

        this.applicationTypeControl_Single = new UntypedFormControl('', Validators.required);
        this.applicationTypeControl_Single.markAsTouched();

        this.applicationTypeControl_Multi = new UntypedFormControl('', Validators.required);
        this.applicationTypeControl_Multi.markAsTouched();

        this.applicationTypeSelectOptions_Single = [...tenant.applicationTypeSelectOptions];
        this.applicationTypeSelectOptions_Multi = [...tenant.applicationTypeSelectOptions];
    }

    onSubmitForm(): void {
        console.log('Single:', this.applicationTypeControl_Single.value);
        console.log('Multi:', this.applicationTypeControl_Multi.value);
        console.log(this.MortgageTotal.value)
    }
}
